import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { everCookie } from "@forproxyband/react-tools";

const useEvercookie = () => {
  const [uid, setUid] = useState("");
  const [isStorageDisabled, setIsStorageDisabled] = useState(false);
  const { t } = useTranslation();

  let ever = null;

  try {
    ever = everCookie.useEverCookie();
  } catch (err) {
    ever = null;
  }

  useEffect(() => {
    if (!ever) {
      setIsStorageDisabled(true);
      toast.warning(
        t("browserInfo.cookiesDisabled") ||
          "Cookies or storage are disabled in your browser",
        { position: "top-right", autoClose: 8000 },
      );
    }
  }, [ever, t]);

  useEffect(() => {
    if (!ever) return;

    const { setEvercookie, localUid, sessionUid, clear, indexedDB, globalUid } =
      ever;

    if (!localUid || !sessionUid || !globalUid) {
      indexedDB
        .then(data => {
          if (data) {
            setUid(data.toString());
            setEvercookie(data.toString());
          } else {
            clear();
          }
        })
        .catch(err => {
          console.warn("Failed to access indexedDB:", err);
          clear();
        });
    } else {
      setUid(localUid);
    }
  }, [ever]);

  const generateEvercookie = () => {
    if (!ever) return;
    const { setEvercookie } = ever;
    const newUid = everCookie.generateEverCookie();
    setUid(newUid.toString());
    setEvercookie(newUid.toString());
  };

  const setAllFields = value => ({
    userData: "N/A",
    cookieData: value,
    localData: value,
    globalData: value,
    sessionData: value,
    windowData: value,
    pngData: value,
    etagData: value,
    cacheData: value,
    lsoData: "N/A",
    dbData: value,
    slData: "N/A",
  });

  const convertToFieldArray = value => {
    const fields = setAllFields(value);
    return Object.keys(fields).map(key => ({
      name: key,
      result: fields[key] === "N/A" ? "N/A" : fields[key],
    }));
  };

  return { uid, generateEvercookie, convertToFieldArray, isStorageDisabled };
};

export default useEvercookie;
